import React, { useEffect, useState } from "react";
import "./index.css";
import CustomButton from "../../Components/Atoms/CustomButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import CustomDialog from "../../Components/Molecules/CustomDialog";
import AddEmployees from "./AddEmployee";
import TablePagination from "../../Components/Molecules/Pagination";
import DoneIcon from "@mui/icons-material/Done";
import {
  getEmployeeListRequest,
  postEmployeeResponseClear,
  putEmployeeRequest,
  putEmployeeResponseClear,
  putStatusEmployeeRequest,
} from "../../Redux/Employees/EmployeesActions";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import NoRecords from "../../Components/Atoms/NoRecord";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EmployeeView from "./EmployeeView";
import AvailableStatus from "../../Components/Atoms/AvailableStatus";
import toast from "react-hot-toast";
import { hasPermission, isSuperAdmin } from "../../Utils/getters";
import { MODULES, ROLE_BY_PERMISSIONS } from "../../Constant";

const Employees = () => {
  const dispatch = useDispatch();

  const {
    EmployeeListPageLoading,
    EmployeeListPageResponse,
    EmployeePostLoading,
    EmployeePostResponse,
  } = useSelector((state) => state.employee);

  const [viewEmployee, setViewEmployee] = useState({
    openView: false,
    employeVieweData: null,
  });

  const { openView, employeVieweData } = viewEmployee;

  const handleOpenView = (data = null) => {
    setViewEmployee({
      openView: true,
      employeVieweData: data,
    });
  };

  const handleCloseView = () => {
    setViewEmployee({
      openView: false,
      employeVieweData: null,
    });
  };

  const [dialogState, setDialogState] = useState({
    open: false,
    employeeData: null,
  });

  const { open, employeeData } = dialogState;

  const handleOpen = (data = null) => {
    setDialogState({
      open: true,
      employeeData: data,
    });
  };

  const handleClose = () => {
    setDialogState({
      open: false,
      employeeData: null,
    });
  };
  const [page, setPage] = useState(1);
  const searchSchema = {
    filters: {
      search: {
        value: "",
      },
    },
    limit: 10,
    page: page,
    sort: "",
  };

  const searchFormik = useFormik({
    initialValues: searchSchema,
    onSubmit: (values) => {
      setPage(1);
      return dispatch(getEmployeeListRequest(values));
    },
  });

  useEffect(() => {
    if (EmployeePostLoading) return;
    dispatch(getEmployeeListRequest({ ...searchFormik.values, page }));
  }, [EmployeePostLoading]);

  const toggleStatus = ({ _id, status }) => {
    dispatch(putStatusEmployeeRequest({ status: !status, id: _id }));
  };

  useEffect(() => {
    if (EmployeePostResponse?.success && EmployeePostResponse?.message) {
      toast.success(EmployeePostResponse?.message);
    } else if (EmployeePostResponse?.response?.data) {
      toast.error(EmployeePostResponse?.response?.data?.message);
    }
    return () => {
      dispatch(postEmployeeResponseClear());
    };
  }, [EmployeePostResponse]);

  const { getUserResponse } = useSelector((state) => state.user);

  return (
    <>
      <CustomDialog
        maxWidth="xl"
        title={
          employeeData
            ? `UPDATE USER - ${employeeData?.employee_id}`
            : "CREATE USER"
        }
        handleClose={() => {
          handleClose();
        }}
        open={open}
      >
        <div>
          <AddEmployees handleClose={handleClose} employeeData={employeeData} />
        </div>
      </CustomDialog>
      <CustomDialog
        maxWidth="lg"
        title={"USER DETAILS"}
        handleClose={() => {
          handleCloseView();
        }}
        open={openView}
      >
        <div>
          <EmployeeView
            handleClose={handleCloseView}
            employeeData={employeVieweData}
          />
        </div>
      </CustomDialog>
      <div className="cntr">
        <div className="hdrComp">
          <h6>USERS LIST</h6>
          {isSuperAdmin(getUserResponse?.data) && (
            <div className="rtActnWrpr">
              <CustomButton
                label={"New User"}
                action={"NEW"}
                onClick={() => handleOpen()}
                size="small"
              />
            </div>
          )}
        </div>

        {EmployeeListPageLoading &&
        !EmployeeListPageResponse?.data?.length > 0 ? (
          <div className="d-flex align-items-center justify-content-center">
            <CircularProgress size={25} />
          </div>
        ) : (
          <div className="tblWrpr">
            <TablePagination
              showFilter={true}
              showSort={true}
              setPage={setPage}
              page={page}
              initialValues={searchSchema}
              formik={searchFormik}
              action={(values) => dispatch(getEmployeeListRequest(values))}
              result={EmployeeListPageResponse}
              count={EmployeeListPageResponse?.data?.total_count}
            >
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>UUID</th>
                      <th>USER ID</th>
                      <th>NAME</th>
                      <th>PHONE NUMBER</th>
                      <th>EMAIL</th>
                      <th>ROLE</th>
                      <th>STATUS</th>
                      <th>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {EmployeeListPageResponse?.data?.length > 0 ? (
                      EmployeeListPageResponse?.data?.map((data, index) => {
                        return (
                          <tr key={data._id}>
                            <td>
                              {(page - 1) * searchFormik.values.limit +
                                index +
                                1}
                            </td>
                            <td>{data?._id}</td>
                            <td>{data?.employee_id}</td>
                            <td>
                              <div className="d-flex gap-2">
                                <p>{data?.first_name}</p>
                                {data?.is_super_admin && (
                                  <AvailableStatus
                                    status={"SUPER ADMIN"}
                                    customCls={"index-red"}
                                  />
                                )}
                              </div>
                            </td>
                            <td>{data?.phone_number}</td>
                            <td>{data?.email}</td>
                            <td>
                              <AvailableStatus
                                status={data?.role?.name?.toUpperCase()}
                                customCls={"index-orange-mild"}
                              />
                            </td>
                            <td>
                              <AvailableStatus
                                status={data?.status ? "ACTIVE" : "INACTIVE"}
                                customCls={
                                  data?.status ? "index-green" : "index-red"
                                }
                              />
                            </td>

                            <td>
                              <div className="view">
                                <button onClick={() => handleOpenView(data)}>
                                  <VisibilityIcon />
                                </button>
                                {isSuperAdmin(getUserResponse?.data) && (
                                  <button onClick={() => handleOpen(data)}>
                                    <EditIcon />
                                  </button>
                                )}
                                {!data?.is_super_admin &&
                                  hasPermission(
                                    [
                                      ROLE_BY_PERMISSIONS[MODULES.EMPLOYEE]
                                        .STATUS_EMPLOYEE,
                                    ],
                                    getUserResponse?.data
                                  ) && (
                                    <button onClick={() => toggleStatus(data)}>
                                      {data.status === true ? (
                                        <RemoveCircleOutlineIcon />
                                      ) : (
                                        <DoneIcon />
                                      )}
                                    </button>
                                  )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <NoRecords />
                    )}
                  </tbody>
                </table>
              </div>
            </TablePagination>
          </div>
        )}
      </div>
    </>
  );
};

export default Employees;
